export default {
  heading: 'Sign in',
  subhead: 'Enter the authentication code we sent to {{email}}.',
  submit: 'Continue',
};
